module.exports = __webpack_public_path__ + "static/media/transparent_step1@2x.d28ed61e.png";